export const RELEASE_DATE = new Date(
  Number(process.env.REACT_APP_GOLIATHS_RELEASE_YEAR),
  Number(process.env.REACT_APP_GOLIATHS_RELEASE_MONTH),
  Number(process.env.REACT_APP_GOLIATHS_RELEASE_DAY)
)

export const MARGIN_RELEASE_DATE = new Date(
  Number(process.env.REACT_APP_MARGIN_RELEASE_YEAR),
  Number(process.env.REACT_APP_MARGIN_RELEASE_MONTH),
  Number(process.env.REACT_APP_MARGIN_RELEASE_DAY)
)

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function formatDate({ date, month = 'numeric', time = false, noDay = false, noMonth = false }) {
  let options = {
    year: 'numeric',
    month,
    day: 'numeric',
  };
  if (noDay) {
    delete options.day
  }
  if (noMonth) {
    delete options.month
  }
  if (time) {
    options = {
      ...options,
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  }
  const toFormat = new Date(date);
  if (!isValidDate(toFormat)) return date
  let dateFormatted = toFormat.toLocaleDateString('fr-FR', options);
  if (noDay) dateFormatted = dateFormatted[0].toUpperCase() + dateFormatted.slice(1)
  return dateFormatted;
}